import { render, staticRenderFns } from "./SfFooterColumn.vue?vue&type=template&id=a1dd1714&"
import script from "./SfFooterColumn.vue?vue&type=script&lang=js&"
export * from "./SfFooterColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports